var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "vue-need-bootstrap h100" }, [
    _c(
      "div",
      {
        staticClass: "d-flex justify-content-center w-100 h-100 overflow-auto",
      },
      [
        !_setup.loading
          ? _c(
              "div",
              { staticClass: "app-container d-flex flex-column h-100" },
              [
                _c("div", { staticClass: "text-center nav-selector" }, [
                  _c(
                    "div",
                    {
                      staticClass: "link",
                      class: { active: _setup.currentPage == "account" },
                      on: {
                        click: function ($event) {
                          _setup.currentPage = "account"
                        },
                      },
                    },
                    [_vm._v("\n                    Account\n                ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { class: { "d-none": !_setup.hasManageIntegrations } },
                    [
                      _vm._v("|\n                    "),
                      _c(
                        "div",
                        {
                          staticClass: "link",
                          class: {
                            active: _setup.currentPage == "integrations",
                          },
                          on: {
                            click: function ($event) {
                              _setup.currentPage = "integrations"
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        Integrations\n                    "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { class: { "d-none": !_setup.displayBillingPanel } },
                    [
                      _vm._v("|\n                    "),
                      _c(
                        "div",
                        {
                          staticClass: "link",
                          class: { active: _setup.currentPage == "billing" },
                          on: {
                            click: function ($event) {
                              _setup.currentPage = "billing"
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        Billing\n                    "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { class: { "d-none": !_setup.hasPODBilling } }, [
                    _vm._v("|\n                    "),
                    _c(
                      "div",
                      {
                        staticClass: "link",
                        class: { active: _setup.currentPage == "podBilling" },
                        on: {
                          click: function ($event) {
                            _setup.currentPage = "podBilling"
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        POD Billing\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { class: { "d-none": !_setup.hasTeam } }, [
                    _vm._v("|\n                    "),
                    _c(
                      "div",
                      {
                        staticClass: "link",
                        class: { active: _setup.currentPage == "team" },
                        on: {
                          click: function ($event) {
                            _setup.currentPage = "team"
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        Team\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _setup.user
                  ? _c(
                      "div",
                      {
                        staticClass: "container d-flex flex-grow-1 h-100 w-100",
                      },
                      [
                        _c(
                          "transition",
                          { attrs: { name: "fade", mode: "out-in" } },
                          [
                            _setup.currentPage == "account"
                              ? _c(
                                  "div",
                                  { key: "account", staticClass: "w-100" },
                                  [
                                    _c(_setup.AccountComponent, {
                                      on: {
                                        "user-updated": _setup.onUserUpdated,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _setup.currentPage == "integrations"
                              ? _c(
                                  "div",
                                  { key: "integrations", staticClass: "w-100" },
                                  [
                                    _c(_setup.Integrations, {
                                      on: {
                                        "user-updated": _setup.onUserUpdated,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _setup.currentPage == "billing"
                              ? _c(
                                  "div",
                                  { key: "billing", staticClass: "w-100" },
                                  [
                                    _c(_setup.Billing, {
                                      on: {
                                        "user-updated": _setup.onUserUpdated,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _setup.currentPage == "podBilling"
                              ? _c(
                                  "div",
                                  { key: "podBilling", staticClass: "w-100" },
                                  [
                                    _c(_setup.PodBilling, {
                                      on: {
                                        "user-updated": _setup.onUserUpdated,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _setup.currentPage == "team"
                              ? _c(
                                  "div",
                                  { key: "team", staticClass: "w-100" },
                                  [
                                    _c(_setup.Team, {
                                      on: {
                                        "user-updated": _setup.onUserUpdated,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _setup.loading
          ? _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-center w-100 h-100 align-items-center",
              },
              [
                _c("b-spinner", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _setup.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "mr-2",
                  attrs: { variant: "primary" },
                }),
              ],
              1
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }